import { useSelector } from 'react-redux';
import { selectUserGuid } from 'slices/commonSelectors';
import { useGetRosterForIncident } from './useRoster';
import { NULL_VALUE } from 'constants/displayConstants';

export const useUserPositions = () => {
  const userGuid = useSelector(selectUserGuid);
  const { data: roster } = useGetRosterForIncident();

  return (
    roster
      ?.find((r) => r.userId === userGuid)
      ?.incidentPositions?.map((pos) => pos.positionName) || [NULL_VALUE]
  );
};
